import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import CustomerType from "../../../containers/modules/master/customer-type";

export default function CustomerTypeRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="customer-type"
      index
      element={
        <AccessControl
          name={"Customer Type List"}
          auth={authUser}
          component={() => <CustomerType authUser={authUser} />}
        />
      }
    />
  );
}
